class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.checkoutForm = this.querySelector('#cart-notification-form');
    if (this.checkoutForm) this.checkoutForm.addEventListener('submit', this.handleCheckoutSubmit.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleCheckoutSubmit(evt) {
    if (this._allowCheckoutSubmit) return;

    evt.preventDefault();
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cart) => {
        if (this.cartHasPlateMissingDocuments(cart)) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        this._allowCheckoutSubmit = true;
        this.ensureCheckoutInput();
        this.checkoutForm.submit();
      })
      .catch(() => {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      });
  }

  cartHasPlateMissingDocuments(cart) {
    return (cart.items || []).some((item) => {
      const title = String(item.product_title || item.title || '').toLowerCase();
      const type = String(item.product_type || '').toLowerCase();
      const needsDocuments = (title.includes('plate') || type.includes('plate')) &&
        !title.includes('keyring') &&
        !title.includes('fitting kit') &&
        !title.includes('fixing kit');

      if (!needsDocuments) return false;

      const properties = item.properties || {};
      return !properties['Proof of Identity'] || !properties['Proof of Entitlement'];
    });
  }

  ensureCheckoutInput() {
    if (this.checkoutForm.querySelector('input[name="checkout"]')) return;

    const checkoutInput = document.createElement('input');
    checkoutInput.type = 'hidden';
    checkoutInput.name = 'checkout';
    checkoutInput.value = 'Checkout';
    this.checkoutForm.appendChild(checkoutInput);
  }
}

customElements.define('cart-notification', CartNotification);
